import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ManPowerDto } from '../models/ManPowerDto';
import { ManpowerRequestVM } from '../models/requests/ManpowerRequestVM';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { approveManPowerVm } from '../models/approveManPowerVm';
import { ManpowerJDDto } from '../models/requests/ManpowerJDDto';
import { ManPowerPendingApprovalDto } from '../models/ManPowerPendingApprovalDto';
import { DateRangeRequest } from '../models/requests/DateRangeRequest';

@Injectable({
  providedIn: 'root'
})
export class ManPowerDraftsService {

  constructor(private httpClient: HttpClient) { }
  
  saveManPower(newManPowerRequest: ManpowerRequestVM): Observable<ApiResponseObject<ManPowerDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto>>(`${environment.apiUrl}/ManpowersDraft`, newManPowerRequest);
  }
  getManPower(): Observable<ApiResponseObject<ManPowerDto[]>> {
    ; 
   var result = this.httpClient.get<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManpowersDraft/GetMyDrafts`);
   return result;
 }

 updateManPower(newManPowerRequest: ManpowerRequestVM): Observable<ApiResponseObject<ManPowerDto>> {
  ;
  return this.httpClient.post<ApiResponseObject<ManPowerDto>>(`${environment.apiUrl}/ManpowersDraft/Edit`, newManPowerRequest);
} 
 
deleteManPowerDraft(id: number): Observable<ApiResponseObject<ManPowerDto>> {
  ;
  return this.httpClient.post<ApiResponseObject<ManPowerDto>>(`${environment.apiUrl}/ManpowersDraft/Delete/${id}`, id);
} 



  fileExtention(name: any ) {
    ;
    const regex = /(?:\.([^.]+))?$/;
    return regex.exec(name)![1];
  }
  
  
  


}


